import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { MailCheck, LogOut } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errorMessage } from "@/lib/api";
import { CodeInput, ResendButton } from "@/components/CodeInput";

export default function VerifyEmail() {
  const { user, setUser, logout } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  if (user?.email_verified === true) { navigate("/inicio", { replace: true }); return null; }

  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/verify-email/confirm", { code });
      setUser(data.user);
      toast.success("E-mail confirmado. Bem-vindo!");
      navigate("/inicio", { replace: true });
    } catch (err) { toast.error(errorMessage(err)); setCode(""); } finally { setBusy(false); }
  };
  const resend = async () => { try { await api.post("/auth/verify-email/send"); toast.success("Novo código enviado."); } catch (err) { toast.error(errorMessage(err)); } };

  return (
    <div className="ga-fade-up mx-auto flex min-h-screen max-w-sm flex-col justify-center px-6 py-10" data-testid="verify-email-page">
      <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-2xl" style={{ background: "#05324A", color: "#33D9B2" }}><MailCheck size={28} /></div>
      <h1 className="text-2xl font-bold">Confirme seu e-mail</h1>
      <p className="ga-muted mt-2 text-sm">Enviamos um código de 6 dígitos para <b className="break-all" data-testid="verify-email-address">{user?.email}</b>. Ele vale por 5 minutos.</p>
      <form onSubmit={confirm} className="mt-6 space-y-3">
        <CodeInput value={code} onChange={setCode} testId="verify-email-code" />
        <button type="submit" disabled={busy || code.length !== 6} className="ga-btn-primary w-full" data-testid="verify-email-submit">{busy ? "Verificando..." : "Confirmar e-mail"}</button>
        <ResendButton onResend={resend} testId="verify-email-resend" />
      </form>
      <button onClick={() => { logout(); navigate("/entrar"); }} className="ga-muted mt-8 flex items-center justify-center gap-1 text-xs" data-testid="verify-email-logout"><LogOut size={12} /> Usar outra conta</button>
    </div>
  );
}
